import reducers from "./reducers";
import { initMenu } from "../../actions/appActions";
import rs from "./routes";
import { fromPairs, flatMap } from "lodash";

export const name = "cro";
export const reducer = reducers;

export const styles = {
  buttons: {
    color: "white",
  },
};

export const routes = flatMap(Object.keys(rs), (key) => rs[key].routes);

// optional init function
export const init = (dispatch) => {
  dispatch(
    initMenu(fromPairs(Object.keys(rs).map((key) => [key, rs[key].menu]))),
  );
};
